// extracted by mini-css-extract-plugin
export var date = "blog-module--date--00052";
export var headline = "blog-module--headline--32fc7";
export var wrapper = "blog-module--wrapper--69d49";